export const createEmptySuccessResponse = (status = 200, statusText = 'OK') =>
  Promise.resolve({
    data: [],
    status,
    statusText,
    headers: {},
    config: {},
  });

export const emptyErrorResponse = createEmptySuccessResponse(422, 'error');
export const emptySuccessResponse = createEmptySuccessResponse(200, 'OK');
export const emptyValidationErrorResponse = createEmptySuccessResponse(400, 'error');
